import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineChangeScheduleField のスタイル
 */
export const hotlineChangeScheduleFieldStyle = tv({
    slots: {
        base: ['flex gap-8 lg:gap-16'],
        field: ['w-[170px] max-w-[170px]', '[&>.react-datepicker-wrapper]:w-full'],
        labelText: ['mb-8'],
    },
});
